// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"5496b94b","236":"4353012d","650":"4cccd386","666":"4a8f695b","722":"576b1214","757":"b374248f","945":"301be336"}[chunkId] + ".chunk.css";
};